import React, { useEffect, useState } from "react";
import "./cssexperience.css";
import { BiSolidBadgeCheck } from "react-icons/bi";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { baseURL } from "../../App";
import i18n from "../../i18n/config";
// import GitHubCalendar from "react-github-calendar";

import SkeletonLoader from "../Skeleton/SkeletonLoader";

const Experience = () => {
  const { t } = useTranslation();

  const [experiences, setExperiences] = useState([]); // State to hold experiences
  const API_URL = `${baseURL}/api/experience`;

  // Error handling and loading state
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const calculateExperienceDuration = (startDate) => {
    const start = new Date(startDate);
    const now = new Date();

    let years = now.getFullYear() - start.getFullYear();
    let months = now.getMonth() - start.getMonth();

    // Adjust for negative months
    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years} ${t("years.title")} ${months} ${t("months.title")}`;
  };

  // Fetch experiences from the backend
  useEffect(() => {
    const fetchExperiences = async () => {
      try {
        const response = await axios.get(API_URL);
        console.log(response.data);
        setExperiences(response.data);
      } catch (error) {
        setError("Error fetching experiences");
        console.error("Error fetching experiences:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchExperiences();
  }, [API_URL]);

  // Handle loading and error states
  if (loading) {
    return (
      <section id="experiences">
        <h5>{t("experience.sub_title")}</h5>
        <h2>{t("experience.title")}</h2>
        <SkeletonLoader type="grid" count={2} />
      </section>
    );
  }
  if (error) return <p>{error}</p>;
  return (
    <section id="experiences">
      <h5>{t("experience.sub_title")}</h5>
      <h2>{t("experience.title")}</h2>
      <div className="container experience_container">
        {experiences.map((experience) => (
          <article className="experience item_scale" key={experience._id}>
            <div className="experience_head">
              <h3>
                {i18n.language === "en"
                  ? experience.categoryEn
                  : experience.categoryFr}
                {/* at {experience.company} */}
              </h3>
              <p className="experience_duration">
                {/* {experience.category} -  */}
                {/* {experience.duration} */}
                {calculateExperienceDuration(experience.startDate)}
              </p>
            </div>
            <ul className="experience_list">
              {experience.skills.map((skill, index) => (
                <li key={index} className="experience_details">
                  <BiSolidBadgeCheck className="experience_list-icon" />
                  <div className="skill_info">
                    <h4>
                      {i18n.language === "en" ? skill.nameEn : skill.nameFr}
                    </h4>
                    <small className="light-text">
                      {i18n.language === "en" ? skill.levelEn : skill.levelFr}
                    </small>
                  </div>
                </li>
              ))}
            </ul>
            <p className="experience_description">
              {i18n.language === "en"
                ? experience.descriptionEn
                : experience.descriptionFr}
            </p>
          </article>
        ))}
      </div>
    </section>
    // <section id="experiences">
    //   <h5>{t("experience.sub_title")}</h5>
    //   <h2>{t("experience.title")}</h2>
    //   <div className="container experience_container">
    //     <div className="item_scale">
    //       <h3>{t("experience.experience_category_1")}</h3>
    //       <div className="experience_content">
    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>HTML5</h4>
    //             <small className="light-text">{t("level.5")}</small>
    //             {/*
    //               0. No Experience
    //               1. Beginner
    //               2.Intermediate / average
    //               3. Advanced / experimented
    //               4. Expert
    //               */}
    //           </div>
    //         </article>

    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>CSS3</h4>
    //             <small className="light-text">{t("level.5")}</small>
    //           </div>
    //         </article>

    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>Javascript</h4>
    //             <small className="light-text">{t("level.2")}</small>
    //           </div>
    //         </article>

    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>Java</h4>
    //             <small className="light-text">{t("level.3")}</small>
    //           </div>
    //         </article>

    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>React</h4>
    //             <small className="light-text">{t("level.4")}</small>
    //           </div>
    //         </article>

    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>C, C++</h4>
    //             <small className="light-text">{t("level.3")}</small>
    //           </div>
    //         </article>

    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>Typescript</h4>
    //             <small className="light-text">{t("level.2")}</small>
    //           </div>
    //         </article>
    //       </div>
    //     </div>

    //     <div className="item_scale">
    //       <h3>{t("experience.experience_category_2")}</h3>
    //       <div className="experience_content">
    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>MySQL</h4>
    //             <small className="light-text">{t("level.4")}</small>
    //           </div>
    //         </article>

    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>Node.JS </h4>
    //             <small className="light-text">{t("level.2")}</small>
    //           </div>
    //         </article>

    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>Express JS </h4>
    //             <small className="light-text">{t("level.3")}</small>
    //           </div>
    //         </article>

    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>MongoDB</h4>
    //             <small className="light-text">{t("level.2")}</small>
    //           </div>
    //         </article>

    //         {/*<article className="experience_details">
    //             <BiSolidBadgeCheck className='experience_details-icon'/>
    //             <div>
    //               <h4>C/C++</h4>
    //               <small className="light-text">{t('experimented')}</small>
    //             </div>
    //           </article>
    // */}

    //         <article className="experience_details">
    //           <BiSolidBadgeCheck className="experience_details-icon" />
    //           <div>
    //             <h4>Java</h4>
    //             <small className="light-text">{t("level.3")}</small>
    //           </div>
    //         </article>
    //       </div>
    //     </div>
    //     {/* <GitHubCalendar
    //         username="aubin9"
    //         // blockSize={15} // Size of the blocks
    //         // blockMargin={5} // Margin between blocks
    //         // color={color} // Color for the contributions
    //         // fontSize={16} // Font size of the text
    //       /> */}
    //   </div>
    // </section>
  );
};

export default Experience;
